'use client';

import { motion } from 'framer-motion';

export const button = motion.button;
